import React from "react";
import LogoDesk from "../../assets/images/logo-escritorio.png";
import Cfdi from "../../assets/images/documento.png";
import {
  LogoCFDI,
  LogoStyled,
  NavItemContainer,
  NavStyled,
  Title,
} from "../../assets/styles/components/Navbar";

export const Navbar = () => {
  return (
    <>
      <NavStyled>
        <NavItemContainer>
          <LogoStyled src={LogoDesk} alt="Logo" />
        </NavItemContainer>
        <NavItemContainer>
          <Title>Facturación Electrónica</Title>
        </NavItemContainer>
        <NavItemContainer>
          <LogoCFDI src={Cfdi} alt="Logo Cfdi" />
        </NavItemContainer>
      </NavStyled>
    </>
  );
};
